import { where } from 'firebase/firestore'
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import _ from 'lodash'
import { useContext, useEffect, useMemo, useState } from 'react'
import { Icon, Label, List, Segment } from 'semantic-ui-react'
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext'
import UiSaveButtons from '../../../../global/components/buttons/UiSaveButtons'
import { createRefPath_event } from '../../../../global/firestoreData/appData/appRefPaths'
import FullPageWrapper from '../../../../global/wrappers/FullPageWrapper'
import Wrapper, { wrapperTypes } from '../../../../global/wrappers/Wrapper'
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import { useSportsSeason } from 'projectSpecific/sports/useHelpers/useSportsSeason'

const SportsSeasons = (props) => {

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}

  const appUserAccess = useAppUserAccess()
  const { isSuperAdminDeveloper } = appUserAccess ?? {}

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ? sportsSeasonContext : {}
  const { currentSeason_info, } = sportsSeason_state ?? {}
  const { latestSeason, sportsKey, _sportsModeKey, _sportsModeSport } = currentSeason_info ?? {}

  const { getSportsSeasons } = useSportsSeason()

  // local state 
  const [sportsYears, setSportsYears] = useState({})
  const [selectedYear, setSelectedYear] = useState()

  // adjust the sports years to show 2 years
  const _sportsYears = useMemo(() => {
    const sys = _.map(sportsYears, sy => {
      return {
        name: sy ? `${sy - 1}-${sy}` : sy,
        key: sy,
        year: sy
      }
    })
    return _.orderBy(sys, ['key'], ['desc'])
  })

  useEffect(() => {
    getSportsSeasons({ sportsKey, callback: setSportsYears })
  }, []);

  const handleCancel = () => {
    setSelectedYear()
    sportsSeason_handlers.handleShow_sportsElem()
    if (props.handleCancel) {
      props.handleCancel()
    }
  }

  const handleSet_tempSelectedSeason = (e, sportsYear) => {
    e.stopPropagation()
    console.log('sportsYear', sportsYear)
    // sportsSeason_handlers.handleSet_tempSelectedSeason(sportsYear)
    if (props.handleCancel) {
      props.handleCancel()
    }
  }

  const handleSet_selectedSeason = (sportsYear) => {
    if (!sportsYear || (_.isObject(sportsYear) && _.isEmpty(sportsYear))) {
      setSelectedYear(null)
    } else {
      if (sportsYear !== selectedYear) {
        setSelectedYear(sportsYear)
      }
    }
  }

  const handleSave_selectedSeason = async () => {
    const _refPath = createRefPath_event(pathViews, ['sports', sportsKey])
    const dataToUpdate = { latestSeason: selectedYear }
    console.log('_refPath', _refPath, dataToUpdate)
    // await database_fns.doc_set(_refPath, dataToUpdate, true)
    // setSelectedYear()
  }


  const fnAlt = (item) => {
    const selected = latestSeason === item.year
    return <Icon
      color={selected ? 'blue' : 'grey'}
      name={selected ? 'check circle outline' : 'circle outline'}
      onClick={(e) => { handleSet_tempSelectedSeason(e, item.year) }}
    />
  }

  const oc_years = (item) => handleSet_selectedSeason(item.year)

  const ims_years = () => <ItemMenuSquares
    menuItems={_sportsYears}
    imsType={_imsTypes.inline}
    ignoreStartCase={true}
    fn_altContent={fnAlt}
    iconItem={'calendar outline'}
    onClick={oc_years}
    style={{ padding: '.5em' }}

  ></ItemMenuSquares>

  const content_save = () => {
    return 'Set the current sports year to ' + selectedYear + '?'
  }

  const footer_season = () => <UiSaveButtons
    save={{ oc: handleSave_selectedSeason, caption: 'Set current year (' + selectedYear + ')' }}
    cancel={{ oc: handleSet_selectedSeason }}
  />

  const wrapper = () => <Wrapper
    content={selectedYear ? content_save() : ims_years()}
    footer={selectedYear && footer_season()}
    wrapperType={selectedYear ? wrapperTypes.padded : wrapperTypes.paddedHeader}
    css={{ container: 'app-dark-mode' }}
  />

  const fpw_seasons = () => <FullPageWrapper
    content={wrapper()}
    handleCancel={handleCancel}
    topperCaption={'Sports Seasons'}
    topperCaption2={_.startCase(_sportsModeKey)}
  ></FullPageWrapper>


  return props?.noFull ? wrapper() : fpw_seasons()
}

export default SportsSeasons
